export default "__VITE_ASSET__DoqVA_lS__"